// src/utils/akkUtils.js

/**
 * BU DOSYA AKK.doc BELGESİNDEKİ STANDARTLARA GÖRE HAZIRLANMIŞTIR.
 * Kaynaklar:
 * - Kodlar: Source 60-66
 * - Sınıflandırma Mantığı: Source 166 (Tespit Cetveli)
 */

// --- 1. DÖNÜŞTÜRÜCÜLER (Kodlama & Standardizasyon) ---

export const getAkkDepthCode = (val) => {
  const cm = parseFloat(val);
  if (isNaN(cm)) return "1";
  if (cm >= 150) return "1";
  if (cm >= 90) return "2";
  if (cm >= 50) return "3";
  if (cm >= 20) return "4";
  return "5";
};

export const getAkkTextureCode = (texStr, kirecStr = "") => {
  if (!texStr) return "M";
  const t = texStr.split(" ")[0].trim().toUpperCase().replace(/İ/g, "I");

  const kirecsizMi =
    !kirecStr ||
    kirecStr.includes("Kireçsiz") ||
    kirecStr.toLowerCase().includes("yok");

  const isKirecli = !kirecsizMi;

  const map = {
    C: "H",
    SIC: "H",
    SC: "H",
    CL: "F1",
    SICL: isKirecli ? "F1" : "F2",
    SCL: "F3",
    L: "M",
    SIL: "M",
    SI: "M",
    VFSL: "M",
    FSL: "S1",
    SL: "S2",
    LFS: "L1",
    LS: "L2",
    S: "V",
  };
  return map[t] || "M";
};

// Egim sinifi + alt rakami: "A", "B1", "C3", "E" ...
// Rakam, AKK belgesindeki egim yuzdesi alt grubudur (B1 %3-4, B2 %5-6 ...).
export const getAkkSlopeCode = (slopeStr) => {
  if (!slopeStr) return "A";
  const s = String(slopeStr).trim();

  if (s === "0-2") return "A";
  if (s === "2-4") return "B1";
  if (s === "4-6") return "B2";
  if (s === "6-8") return "C1";
  if (s === "8-10") return "C2";
  if (s === "10-12") return "C3";
  if (s === "12-14") return "D1";
  if (s === "14-16") return "D2";
  if (s === "16-18") return "D3";
  if (s === "18-20") return "D4";
  if (s === "20-30") return "E";
  if (s === "30-45") return "F";
  if (s === "45+") return "G";

  // Listede olmayan araliklarda ("20-25", "6-12" gibi) ARALIGIN UST SINIRI
  // esas alinir. Eskiden ilk sayiya bakildigi icin "20-25" D, "6-12" B
  // cikiyordu; ust sinira gore bakinca listedeki eslesmelerle tutarli olur.
  const sayilar = (s.match(/\d+(?:[.,]\d+)?/g) || []).map((n) =>
    parseFloat(n.replace(",", ".")),
  );
  if (sayilar.length === 0) return "A";
  if (s.includes("+") && sayilar.length === 1 && sayilar[0] >= 45) return "G";
  const num = Math.max(...sayilar);

  if (num <= 2) return "A";
  if (num <= 4) return "B1";
  if (num <= 6) return "B2";
  if (num <= 8) return "C1";
  if (num <= 10) return "C2";
  if (num <= 12) return "C3";
  if (num <= 14) return "D1";
  if (num <= 16) return "D2";
  if (num <= 18) return "D3";
  if (num <= 20) return "D4";
  if (num <= 30) return "E";
  if (num <= 45) return "F";
  return "G";
};

export const getLandUseCode = (useStr) => {
  if (!useStr) return "K";
  const s = useStr.toLowerCase();

  if (s.includes("nadassız")) return "N";
  if (s.includes("kuru")) return "K";
  if (s.includes("sulanan")) return "Sy";
  if (s.includes("sulu")) return "S";
  if (s.includes("çayır")) return "Ç";
  if (s.includes("bahçe")) return "B";
  if (s.includes("bağ")) return "Ba";
  if (s.includes("mera")) return "M";
  if (s.includes("terk")) return "T";
  if (s.includes("funda") || s.includes("çalı")) return "F";
  if (s.includes("hali") || s.includes("boş")) return "H";
  if (s.includes("özel")) return "Z";
  if (s.includes("orman")) return "O";
  if (s.includes("ırmak")) return "IY";

  return "K";
};

export const getAkkTextureAndPerm = (texStr, kirecStr = "") => {
  if (!texStr) return { code: "M", perm: "O", val: 4 };

  const t = texStr.split(" ")[0].trim().toUpperCase().replace(/İ/g, "I");
  const isKirecli = kirecStr && kirecStr !== "Hiç Yok";

  const map = {
    C: { code: "H", perm: "ÇY", val: 1 },
    SIC: { code: "H", perm: "ÇY", val: 1 },
    SC: { code: "H", perm: "ÇY", val: 1 },
    CL: { code: isKirecli ? "F1" : "F2", perm: "Y", val: 2 },
    SICL: { code: isKirecli ? "F1" : "F2", perm: "Y", val: 2 },
    SCL: { code: "F3", perm: "OY", val: 3 },
    L: { code: "M", perm: "O", val: 4 },
    SIL: { code: "M", perm: "O", val: 4 },
    SI: { code: "M", perm: "O", val: 4 },
    VFSL: { code: "M", perm: "O", val: 4 },
    FSL: { code: "S", perm: "OH", val: 5 },
    SL: { code: "S", perm: "OH", val: 5 },
    LFS: { code: "L", perm: "H", val: 6 },
    LS: { code: "L", perm: "H", val: 6 },
    S: { code: "V", perm: "ÇH", val: 7 },
  };

  return map[t] || { code: "M", perm: "O", val: 4 };
};

// AKK sinifi hicbir zaman V (5) veya VIII (8) olamaz:
//   5 -> 6'ya yukseltilir, 8 -> 7'de kalir.
export const akkSinifDuzelt = (rakam) => {
  if (rakam === 5) return 6;
  if (rakam >= 8) return 7;
  return rakam;
};

// --- 2. HESAPLAMA MOTORU (AKK Tespit Cetveli Mantığı) ---

const getTableHamSinif = (
  cetvel,
  depth,
  tex,
  isCokYavas,
  isHizli,
  slopeCode,
  eroStr,
) => {
  const pureSlope = String(slopeCode).replace(/[0-9]/g, "").trim();
  let se = pureSlope + String(eroStr);

  // Belgeye göre: Düz arazide (A) erozyon teorik olarak 1 kabul edilir.
  if (slopeCode === "A") se = "A1";

  // G eğimi (Sarp) şartsız 8. sınıftır.
  if (slopeCode === "G") return 8;

  // E ve F eğimlerinde erozyon rakamı girilmese bile varsayılan 1 olarak düzeltiyoruz
  if (se.startsWith("E") && se.length === 1) se = "E1";
  if (se.startsWith("F") && se.length === 1) se = "F1";

  // Kesin eşleşme (startsWith yerine exact match kullanıyoruz ki D1 ile D12 karışmasın)
  const match = (arr) => arr.includes(se);

  // --- GEÇİRGENLİK TAYİNİ (VARSAYILAN ORTA) ---
  let perm = "O";
  if (isCokYavas) perm = "ÇY";
  if (isHizli) perm = "H";

  const row = `${depth}_${tex}_${perm}`;

  // ==========================================
  // CETVEL 1: Ege, Marmara, Karadeniz, Akdeniz
  // ==========================================
  if (cetvel === 1) {
    // 1. GRUP: Sığ Araziler (Kaba-Hızlı Hariç) - S_O_O, S_İ_O, S_K_O hep aynıdır
    if (["S_O_O", "S_İ_O", "S_K_O"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 2;
      if (match(["B3", "C1", "C2", "D1"])) return 3;
      if (match(["C3", "C4", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3"])) return 6;
      return 7;
    }

    // 2. GRUP: Sığ + Kaba + Hızlı
    if (row === "S_K_H") {
      if (match(["A1", "B1", "B2"])) return 3;
      if (match(["B3", "C1", "C2", "D1"])) return 4;
      if (match(["C3", "C4", "D2", "D3"])) return 6;
      return 7;
    }

    // 3. GRUP: Çok Sığ Araziler (ÇS_K_H Hariç)
    if (["ÇS_O_O", "ÇS_İ_O", "ÇS_K_O"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 3;
      if (match(["B3", "C1", "C2", "D1"])) return 4;
      if (match(["C3", "C4", "D2", "D3"])) return 6;
      return 7;
    }

    // 4. GRUP: Çok Sığ + Kaba + Hızlı
    if (row === "ÇS_K_H") {
      if (match(["A1", "B1", "B2"])) return 6;
      return 7;
    }

    // 5. GRUP: Derin (D) - Orta/İnce - Orta Geçirgen
    if (["D_O_O", "D_İ_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2", "B3"])) return 2;
      if (match(["C1", "C2", "C3", "D1"])) return 3;
      if (match(["C4", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 6. GRUP: Derin (D) - İnce (İ) - Çok Yavaş (ÇY) -> KRİTİK FARK!
    if (["D_İ_ÇY"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 2;
      if (match(["B3", "C1", "C2"])) return 3;
      if (match(["C3", "C4", "D1", "D2"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 7. GRUP: Derin (D) - Kaba (K) - Orta Geçirgen
    if (["D_K_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2", "B3"])) return 2;
      if (match(["C1", "C2", "C3"])) return 3;
      if (match(["C4", "D1", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 8. GRUP: Derin (D) - Kaba (K) - Hızlı (H) -> KRİTİK FARK!
    if (row === "D_K_H") {
      if (match(["A1", "B1", "B2", "B3"])) return 3;
      if (match(["C1", "C2", "C3", "D1", "D2"])) return 4;
      if (match(["C4", "D3", "D4"])) return 6;
      return 7;
    }

    // 9. GRUP: Orta Derin (OD) - Tümü (Orta Derinlikte bünye ve geçirgenlik sınıf değiştirtmez, belgede hepsi aynıdır)
    if (["OD_O_O", "OD_İ_O", "OD_K_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2"])) return 2;
      if (match(["B3", "C1", "C2", "C3", "D1"])) return 3;
      if (match(["C4", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // ==========================================
    // CETVEL 2: İç, Doğu ve G.Doğu Anadolu
    // ==========================================
  } else {
    // 1. GRUP: Sığ Araziler (Kaba-Hızlı Hariç)
    if (["S_O_O", "S_İ_O", "S_K_O"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 3;
      if (match(["B3", "C1", "C2", "C3", "D1"])) return 4;
      if (match(["C4", "D2", "D3", "E1", "E2", "E3"])) return 6;
      return 7;
    }

    // 2. GRUP: Sığ + Kaba + Hızlı
    if (row === "S_K_H") {
      if (match(["A1", "B1", "B2"])) return 4;
      if (match(["B3", "C1", "C2", "C3", "D1"])) return 6;
      return 7;
    }

    // 3. GRUP: Çok Sığ Araziler (ÇS_K_H Hariç)
    if (["ÇS_O_O", "ÇS_İ_O", "ÇS_K_O"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 4;
      if (match(["B3", "C1", "C2"])) return 6;
      return 7;
    }

    // 5. GRUP: Derin (D) - Orta/İnce - Orta Geçirgen
    if (["D_O_O", "D_İ_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2", "B3"])) return 2;
      if (match(["C1", "C2", "C3", "D1"])) return 3;
      if (match(["C4", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 6. GRUP: Derin (D) - İnce (İ) - Çok Yavaş (ÇY) -> KRİTİK FARK!
    if (["D_İ_ÇY"].includes(row)) {
      if (match(["A1", "B1", "B2"])) return 2;
      if (match(["B3", "C1", "C2"])) return 3;
      if (match(["C3", "C4", "D1", "D2"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 7. GRUP: Derin (D) - Kaba (K) - Orta Geçirgen
    if (["D_K_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2", "B3"])) return 2;
      if (match(["C1", "C2", "C3"])) return 3; // Orijinal belgedeki (A1B123) yazım hatası düzeltildi
      if (match(["C4", "D1", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 8. GRUP: Derin (D) - Kaba (K) - Hızlı (H) -> KRİTİK FARK!
    if (row === "D_K_H") {
      if (match(["A1", "B1", "B2", "B3", "C1", "C2", "C3", "D1"])) return 3;
      if (match(["D2", "D3", "D4"])) return 4;
      if (match(["E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }

    // 9. GRUP: Orta Derin (OD) - Tümü
    if (["OD_O_O", "OD_İ_O", "OD_K_O"].includes(row)) {
      if (match(["A1"])) return 1;
      if (match(["B1", "B2"])) return 2;
      if (match(["B3", "C1", "C2", "C3", "D1"])) return 3;
      if (match(["C4", "D2", "D3"])) return 4;
      if (match(["D4", "E1", "E2", "E3", "F1", "F2"])) return 6;
      return 7;
    }
  }

  // Uç bir senaryo gelir ve hiçbir bloğa girmezse güvenli liman olarak 6 dönüyoruz.
  return 6;
};

export const calculateAkkClass = (data) => {
  // 1. ADIM: TABLO BİLEŞENLERİNİ ÇEKME
  const bolge = data.bolge || "Marmara";
  const cetvelNo = ["İç Anadolu", "Doğu Anadolu", "Güneydoğu Anadolu"].includes(
    bolge,
  )
    ? 2
    : 1;

  const slopeCode = getAkkSlopeCode(data.egim_yuzde);
  const eroStr = data.su_erozyon_derecesi
    ? String(data.su_erozyon_derecesi).charAt(0)
    : "1";

  const rawDepth = getAkkDepthCode(data.tesirli_derinlik);
  let tableDepth = "D";
  if (rawDepth === "3") tableDepth = "OD";
  if (rawDepth === "4") tableDepth = "S";
  if (rawDepth === "5") tableDepth = "ÇS";

  const rawTex = getAkkTextureCode(
    data.horizons?.[0]?.tekstur,
    data.horizons?.[0]?.kirec,
  );
  let tableTex = "O";
  if (rawTex.startsWith("H") || rawTex.startsWith("F")) tableTex = "İ";
  else if (rawTex === "M" || rawTex.startsWith("S")) tableTex = "O";
  else if (rawTex.startsWith("L") || rawTex === "V") tableTex = "K";

  const horizons = data.horizons || [];
  let targetHorizon = null;
  if (horizons.length > 0) {
    if (horizons.length === 1) targetHorizon = horizons[0];
    else if (horizons.length === 2) targetHorizon = horizons[1];
    else targetHorizon = horizons[horizons.length - 2];
  }

  const texInfo = getAkkTextureAndPerm(
    targetHorizon?.tekstur,
    targetHorizon?.kirec,
  );
  const formulaPermeabilityValue = texInfo.val;

  let tablePerm = "O";
  const p = texInfo.perm;
  if (p === "ÇY") tablePerm = "ÇY";
  else if (p === "Y" || p === "OY") tablePerm = "Y";
  else if (p === "OH" || p === "H" || p === "ÇH") tablePerm = "H";
  else tablePerm = "O";

  // Data objesinden gelen tıkları değişkene al (Yoksa false)
  const isCokYavas = data.is_gecirgenlik_cok_yavas === true;
  const isHizli = data.is_gecirgenlik_hizli === true;

  const hamSinif = getTableHamSinif(
    cetvelNo,
    tableDepth,
    tableTex,
    isCokYavas,
    isHizli,
    slopeCode,
    eroStr,
  );

  // ====================================================================
  // 3. ADIM: CEZA FAKTÖRLERİ VE LİMİT HESABI
  // ====================================================================

  let sinifTuz = 0;
  if (data.tuzluluk) {
    if (data.tuzluluk.includes("Hafif") || data.tuzluluk.includes("2"))
      sinifTuz = 1;
    if (
      data.tuzluluk.includes("Orta") ||
      data.tuzluluk.includes("3") ||
      data.tuzluluk.includes("4") ||
      data.tuzluluk.includes("5")
    )
      sinifTuz = 2;
    if (data.tuzluluk.includes("Çok") || data.tuzluluk.includes("6"))
      sinifTuz = 3;
  }

  let sinifAlkali = 0;
  if (data.alkalilik) {
    if (data.alkalilik.includes("X2")) sinifAlkali = 1;
    if (data.alkalilik.includes("X3")) sinifAlkali = 2;
    if (data.alkalilik.includes("X4")) sinifAlkali = 3;
  }

  // Sinif atlatan yuzey unsurlari: TASLILIK ve KAYALILIK.
  // Cakillilik sinif atlatmaz (AKK harita lejantinda da cakil yer almaz);
  // bu yuzden hesaba katilmiyor.
  let sinifTas = 0;
  const tasStr = data.taslilik || "";
  const kayStr = data.kayalilik || "";

  if (
    tasStr.includes("T2") ||
    tasStr.includes("Orta") ||
    kayStr.includes("R2") ||
    kayStr.includes("Orta")
  ) {
    sinifTas = 1;
  }
  if (
    tasStr.includes("T3") ||
    tasStr.includes("Çok") ||
    kayStr.includes("R3") ||
    kayStr.includes("R4") ||
    kayStr.includes("Pek Çok")
  ) {
    sinifTas = 2;
  }

  let sinifDrenaj = 0;
  const drenajStr = data.tabii_drenaj || "";
  if (drenajStr.includes("Kifayetsiz") || drenajStr.includes("(K)"))
    sinifDrenaj = 1;
  if (drenajStr.includes("Fena") || drenajStr.includes("(F")) sinifDrenaj = 2;

  let sinifSel = 0;
  if (data.sel_basmasi) {
    if (data.sel_basmasi.includes("F1")) sinifSel = 1;
    if (data.sel_basmasi.includes("F2")) sinifSel = 2;
    if (data.sel_basmasi.includes("F3")) sinifSel = 3;
  }

  const kimyasalEk = Math.max(sinifTuz, sinifAlkali);

  const penalties = [
    { name: "Tuzluluk / Alkalilik", val: kimyasalEk },
    { name: "Taşlılık / Kayalılık", val: sinifTas },
    { name: "Kötü Drenaj", val: sinifDrenaj },
    { name: "Taşkın / Sel Riski", val: sinifSel },
  ];

  penalties.sort((a, b) => b.val - a.val);
  const biggestPenalty = penalties[0];

  let finalRakam = hamSinif + kimyasalEk + sinifTas + sinifDrenaj + sinifSel;
  let altRakam = finalRakam - biggestPenalty.val;

  if (finalRakam > 8) finalRakam = 8;
  if (slopeCode === "A" && finalRakam > 5) finalRakam = 5;

  if (altRakam > 8) altRakam = 8;
  if (slopeCode === "A" && altRakam > 5) altRakam = 5;
  if (altRakam < 1) altRakam = 1;

  // SON KONTROL: AKK sinifi hicbir zaman V veya VIII olamaz.
  //   V  cikarsa VI'ya yukseltilir (ornek: IV + 1 atlama -> VI)
  //   VIII cikarsa VII'de kalir   (ornek: VII + 1 atlama -> VII)
  finalRakam = akkSinifDuzelt(finalRakam);
  altRakam = akkSinifDuzelt(altRakam);

  let subClassString = "";
  let limits = [];
  if (finalRakam > 1) {
    if (slopeCode !== "A" || parseInt(eroStr) >= 2) limits.push("e");
    if (sinifDrenaj >= 1 || sinifSel >= 1) limits.push("w");
    if (
      sinifTuz >= 1 ||
      sinifAlkali >= 1 ||
      sinifTas >= 1 ||
      tableDepth === "S" ||
      tableDepth === "ÇS"
    )
      limits.push("s");
    subClassString = [...new Set(limits)].join("");
  }

  const roman = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII"];
  const finalClass = roman[finalRakam - 1] || "VIII";
  const alternateClass = roman[altRakam - 1] || "I";

  // ====================================================================
  // 4. ADIM: FORMUL
  // ====================================================================
  // Formul metni YALNIZCA akkFormulParcalari / akkFormulu uzerinden uretilir.
  // Kart, morfoloji, izah cetveli ve T-sablon ayni fonksiyonu kullanir;
  // boylece hicbir ciktida farkli bir formul gorunmez.
  const parca = akkFormulParcalari(data, formulaPermeabilityValue);

  return {
    finalClass,
    subClassString,
    formulaPermeability: formulaPermeabilityValue,
    limitingFactor: biggestPenalty.name,
    penaltyValue: biggestPenalty.val,
    alternateClass: alternateClass,
    numerator: parca.akkPay.join(" "),
    denominator: parca.akkPayda,
    sideFactors: parca.akkYan.join(" "),
    fullFormulaString: akkFormulMetni(parca),
  };
};

// =============================================================================
// 5. ORTAK FORMUL URETICI (AKK + INDEKS)
// =============================================================================
// Kaynak: AKK.doc "Sembollerin Sirasi" ve AKK harita lejanti.
//
//          1 F2 M2 3 F 2
//     V  -----------------  Ç T2 R1 K F1
//             2 B-2
//
//   V  profil grubu            -> YALNIZCA indeks
//   1  toprak derinligi
//   F2 ust toprak bunyesi (+birim rakami yalnizca indekste)
//   M2 alt toprak bunyesi (+gecirgenlik rakami yalnizca indekste)
//   3  tuzluluk sinifi (1 = tuzsuz, yazilmaz)
//   F  tabii drenaj (iyi drenaj yazilmaz)
//   2 B-2  egim yuzdesi (yalnizca indeks) / egim sinifi - erozyon
//   Ç T2 R1 K F1  cakil (yalnizca indeks) / tas / kaya / kullanim / sel
//
// Yazim: her unsurun arasinda BIR bosluk:
//   AKK   : [(3 F F) / (C - 2)] T2 R0 K
//   INDEKS: XII [(3 F2 F) / (3 C - 2)] Ç2 T2 R0 K
// Olmayan unsurun yerine hicbir sey yazilmaz.
// =============================================================================

// "Drenaja gereksinim var (F1)" -> "F1"
const parantezKodu = (v) => {
  const m = String(v ?? "").match(/\(([^()]*)\)\s*$/);
  return m ? m[1].trim() : "";
};

// "T2 - Orta Taşlı(%10 - %50)" -> "T2" ; "Taşsız" / "Yok" -> ""
const harfRakamKodu = (v, harf) => {
  const s = String(v ?? "")
    .trim()
    .toLocaleUpperCase("tr-TR");
  const m = s.match(new RegExp("^" + harf + "\\s*(\\d)"));
  return m ? harf + m[1] : "";
};

// Tabii drenaj kodu: "İ" | "K" | "F1" | "F2" | "F3" | ""
export const drenajKodu = (v) => {
  if (!v) return "";
  const kod = parantezKodu(v).toLocaleUpperCase("tr-TR");
  if (kod === "İ" || kod === "I") return "İ";
  if (kod === "K") return "K";
  if (/^F[1-3]$/.test(kod)) return kod;
  // Eski kayitlar yazili gelebiliyor
  const s = String(v).toLocaleLowerCase("tr-TR");
  if (s.includes("fena")) return "F1";
  if (s.includes("kifayetsiz") || s.includes("yetersiz")) return "K";
  if (s.includes("iyi")) return "İ";
  return "";
};

// Arazi kullanim kodu. Bos ise bos doner (varsayilan uydurulmaz).
const kullanimKodu = (v) => {
  if (!v) return "";
  return parantezKodu(v) || getLandUseCode(v);
};

// Tuzluluk rakami (AKK olcegi 1/2/3/6); tuzsuz (1) ve bos -> ""
const tuzlulukKodu = (v) => {
  const m = String(v ?? "").match(/\d+/);
  if (!m) return "";
  return m[0] === "1" ? "" : m[0];
};

export const akkFormulParcalari = (data = {}, gecirgenlik) => {
  const horizons = Array.isArray(data.horizons) ? data.horizons : [];
  const h0 = horizons[0] || {};
  const h1 = horizons[1];

  const derinlik = getAkkDepthCode(data.tesirli_derinlik);
  // Cok sig toprakta (0-20 cm, kod 5) tek katman vardir: alt toprak bunyesi
  // yazilmaz. (AKK.doc: "alt toprak olmadigi hallerde toprak bunyesi yalniz
  // tek bir harfle ifade edilir.")
  const cokSig = derinlik === "5";

  const ustHam = h0.tekstur ? getAkkTextureCode(h0.tekstur, h0.kirec) : "";
  const altHam = cokSig
    ? ""
    : h1 && h1.tekstur
      ? getAkkTextureCode(h1.tekstur, h1.kirec)
      : ustHam;

  const ustHarf = ustHam.replace(/[0-9]/g, "");
  const altHarf = altHam.replace(/[0-9]/g, "");

  // Alt toprak gecirgenlik rakami (yalnizca indeks); orta (4) ise yazilmaz.
  const gec = Number(gecirgenlik);
  const gecRakam = altHarf && gec && gec !== 4 ? String(gec) : "";

  const tuz = tuzlulukKodu(data.tuzluluk);
  const dr = drenajKodu(data.tabii_drenaj);
  const drenaj = dr === "K" ? "K" : dr.startsWith("F") ? "F" : "";

  const egim = getAkkSlopeCode(data.egim_yuzde);
  const egimHarf = egim.charAt(0);
  const egimRakam = egim.slice(1);
  const erozyon = data.su_erozyon_derecesi
    ? String(data.su_erozyon_derecesi).trim().charAt(0)
    : "1";

  const cakil = harfRakamKodu(data.cakillilik, "Ç");
  const tas = harfRakamKodu(data.taslilik, "T");
  const kaya = harfRakamKodu(data.kayalilik, "R");
  const kullanim = kullanimKodu(data.arazi_kullanim_sinif);
  const sel = (String(data.sel_basmasi ?? "").match(/F[1-3]/) || [""])[0];

  const grup = String(data.profilgrup ?? "").trim();

  return {
    grup,
    derinlik,
    ustHarf,
    ustHam,
    altHarf,
    gecRakam,
    tuz,
    drenaj,
    egimHarf,
    egimRakam,
    erozyon,
    cakil,
    tas,
    kaya,
    kullanim,
    sel,
    // AKK: indekse ozgu unsurlar (grup, bunye birimi, gecirgenlik, egim
    // yuzdesi) ve CAKIL yer almaz.
    akkPay: [derinlik, ustHarf, altHarf, tuz, drenaj].filter(Boolean),
    akkPayda: `${egimHarf} - ${erozyon}`,
    akkYan: [tas, kaya, kullanim, sel].filter(Boolean),
    // INDEKS: resmi formulun tamami
    indeksPay: [derinlik, ustHam, altHarf + gecRakam, tuz, drenaj].filter(
      Boolean,
    ),
    indeksPayda: [egimRakam, egimHarf].filter(Boolean).join(" ") +
      ` - ${erozyon}`,
    indeksYan: [cakil, tas, kaya, kullanim, sel].filter(Boolean),
  };
};

const akkFormulMetni = (p) =>
  `[(${p.akkPay.join(" ")}) / (${p.akkPayda})]` +
  (p.akkYan.length ? " " + p.akkYan.join(" ") : "");

const indeksFormulMetni = (p) =>
  (p.grup ? p.grup + " " : "") +
  `[(${p.indeksPay.join(" ")}) / (${p.indeksPayda})]` +
  (p.indeksYan.length ? " " + p.indeksYan.join(" ") : "");

// Dis kullanim: butun ciktilar bu iki fonksiyonu cagirir.
export const akkFormulu = (data = {}) =>
  calculateAkkClass(data).fullFormulaString;

export const indeksFormulu = (data = {}) =>
  indeksFormulMetni(
    akkFormulParcalari(data, calculateAkkClass(data).formulaPermeability),
  );
